import { getImages as getPayments } from '../global/helpers';

import { PaymentsKey } from '../constants/Keys';

import { useQuery } from 'react-query';

export const useFetchPayments = (url) => {
  return useQuery(PaymentsKey, () => getPayments(url).then((resp) => resp.data));
};
